import { createContext } from "react";

import { OrgSearchQuery, RegionSearchOrg } from "../types/search-display";

type OrgSearchQueryContextType = {
  orgSearchQueryState: OrgSearchQuery;
  setOrgSearchQueryState: React.Dispatch<React.SetStateAction<OrgSearchQuery>>;
};

type UsOrgSearchContextType = {
  usRegionSearchOrgs: RegionSearchOrg;
  setUsRegionSearchOrgs: React.Dispatch<React.SetStateAction<RegionSearchOrg>>;
};

type EuOrgSearchContextType = {
  euRegionSearchOrgs: RegionSearchOrg;
  setEuRegionSearchOrgs: React.Dispatch<React.SetStateAction<RegionSearchOrg>>;
};

type AuOrgSearchContextType = {
  auRegionSearchOrgs: RegionSearchOrg;
  setAuRegionSearchOrgs: React.Dispatch<React.SetStateAction<RegionSearchOrg>>;
};

export const OrgSearchQueryContext = createContext<OrgSearchQueryContextType>(
  {} as OrgSearchQueryContextType,
);

export const UsOrgSearchContext = createContext<UsOrgSearchContextType>(
  {} as UsOrgSearchContextType,
);

export const EuOrgSearchContext = createContext<EuOrgSearchContextType>(
  {} as EuOrgSearchContextType,
);

export const AuOrgSearchContext = createContext<AuOrgSearchContextType>(
  {} as AuOrgSearchContextType,
);
